module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "histroy"
    }
  }, [_c('ul', _vm._l((_vm.historyItems), function(historyItem, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": historyItem.url
      }
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: ('images/' + historyItem.code + '.jpg'),
        expression: "'images/' + historyItem.code +'.jpg'"
      }],
      attrs: {
        "src": 'images/' + historyItem.code + '.jpg',
        "name": historyItem.name
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img_remind clearfix"
    }, [_c('span', [_vm._v("活动已结束！")]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(historyItem.pageView ? historyItem.pageView : 0))]), _c('img', {
      attrs: {
        "src": require("../assets/images/heart_03.png")
      }
    })])])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf4b1e72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/History.vue
// module id = 64
// module chunks = 0